<template>
  <div class="ue-test-table-wrap">
    <a-table :loading="loading" :pagination="pagination" :columns="dataColumns" :data-source="dataSource" ref="user-test-table" bordered size="small">
      <div slot="review_time" slot-scope="text">
        <span>{{formatTime(text)}}</span>
      </div>
      <div slot="decimal_num" slot-scope="text">
        <span>{{isNumber(text)? (text===0 ? '0' :text.toFixed(1)) :''}}</span>
      </div>
      <div slot="platform" slot-scope="text">
        <a-icon class="i-platform" type="android" v-if="text.indexOf('Android') > -1" />
        <a-icon class="i-platform" type="apple" v-if="text.indexOf('iOS') > -1" />
        <a-icon class="i-platform i-platform-xgp" v-if="text.indexOf('手柄版（XGP）') > -1" />
      </div>
      <div slot="platform_text" slot-scope="text">
        <span v-if="text.indexOf('Android') > -1" >Android</span>
        <span v-if="text.indexOf('iOS') > -1" >iOS</span>
        <span v-if="text.indexOf('手柄版（XGP）') > -1" >手柄版<br/>（XGP）</span>
      </div>
      <div slot="remark" slot-scope="text" class="remark-text">{{text}}</div>
      <div slot="operator" slot-scope="record">
        <a-button type="link" size="small" @click="handleEdit(record)">编辑</a-button>
        <a-popconfirm :title="`确认删除玩家 ${record.review_id}？`" @confirm="deleteUserTest(record)">
          <a-button type="link" size="small" :style="{color: '#ff4d4f'}" >删除</a-button>
        </a-popconfirm>
      </div>
      <div slot="remark-operator" slot-scope="record">
        <a-button type="link" size="small" @click="handleEditRemark(record)">编辑</a-button>
        <a-button type="link" size="small" @click="handleSelectDate(record)">查看</a-button>
      </div>
    </a-table>    
    <a-drawer :title="`编辑玩家 ${editItem ? editItem.review_id : '-'}`" :visible="drawerVisible" :width="418" @close="handleCancelEdit">
      <a-form :form="form" ref="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
        <a-form-item v-if="!isSimple" label="性别">
          <a-radio-group v-decorator="['gender']" button-style="solid">
            <a-radio-button value="男">男</a-radio-button>
            <a-radio-button value="女">女</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item v-if="!isSimple" label="年龄">
          <a-input-number :style="{width: '100%'}" placeholder="请输入年龄" v-decorator="['age']" :min="1" :max="100" :precision="0" />
        </a-form-item>
        <a-form-item label="职业">
          <a-input placeholder="请输入职业" v-decorator="['job']"/>
        </a-form-item>
        <a-form-item label="测试时间">
          <a-date-picker :style="{width: '100%'}" format="YYYY-MM-DD" v-decorator="['review_time', {type: 'object'}]" />
        </a-form-item>
        <a-form-item v-if="!isSimple" label="平台">
          <a-radio-group v-decorator="['platform']" button-style="solid">
            <a-radio-button value="iOS">iOS</a-radio-button>
            <a-radio-button value="Android">Android</a-radio-button>
            <a-radio-button value="手柄版（XGP）">手柄版（XGP）</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item :label="`${rateLabel}评分`">
          <a-input-number :style="{width: '100%'}" placeholder="请输入评分 [-5, 5]" v-decorator="['rate']" :min="-5" :max="5" :precision="0" />
        </a-form-item>
        <a-form-item v-if="!isSimple" v-for="fmr in formModeRates" :key="fmr.tarKey" :label="fmr.label">
          <a-input-number :style="{width: '100%'}" placeholder="请输入评分 [-5, 5]" v-decorator="[`${fmr.tarKey}`]" :min="-5" :max="5" :precision="0" />
        </a-form-item>
        <a-form-item label="评分备注">
          <a-textarea placeholder="请输入备注" v-decorator="['remark']" :autosize="{ minRows: 4, maxRows: 8 }"/>
        </a-form-item>
        <a-form-item v-if="!isSimple" label="主测人">
          <a-input placeholder="请输入主测人" v-decorator="['facilitator']"/>
        </a-form-item>
      </a-form>
      <div :style="{display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: '20px'}">
        <a-button :style="{ marginRight: '24px' }" @click="handleCancelEdit">取消</a-button>
        <a-button type="primary" @click="handleConfirmEdit">确认修改</a-button>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import moment from "moment"
import { exportFile } from '@/utils/xlsx.js';
import Clipboard from 'clipboard';
import _ from 'lodash';
import { MODE_ID_MAP, CATEGORY_TYPE_MAP } from '@/constants/fixed';

export default {
  name: 'UxTestTable',
  props: ['data', 'loading', 'canEdit', 'selectedDate', 'selectedPlatform', 'remarkMap', 'selectedMode', 'modeOptions', 'isSimple', 'selectedCategoryType'],
  data() {
    return {
      pagination: {
        pageSize: 30,
        showSizeChanger: true,
        showQuickJumper: true,
        size: "middle",
      },
      drawerVisible: false,
      editItem: undefined,
      form: this.$form.createForm(this, {name: 'edit-ux-test'}),
    }
  },
  computed: {
    dataColumns() {
      if (this.selectedDate) {
        return this.isSimple
          ? [
              { id: 'review_id', title: '序号', dataIndex: 'review_id', width: 48 },
              { id: 'user_occupation', title: '职业', dataIndex: 'user_occupation', width: 100 },
              { id: 'review_time', title: '测试时间', dataIndex: 'review_time', scopedSlots: { customRender: 'review_time' }, width: 110 },
              { id: 'rate', title: `${this.selectedMode?.label}评分`, dataIndex: 'rate', width: 110 },
              { id: 'remark', title: '评分备注', dataIndex: 'remark', scopedSlots: { customRender: 'remark' }, },
              ...(this.canEdit ? [{ id: 'operator', title: '操作', scopedSlots: { customRender: 'operator' }, width: 120 }] : [])
            ]
          : [
              { id: 'review_id', title: '序号', dataIndex: 'review_id', width: 48 },
              // { id: 'user_gender', title: '性别', dataIndex: 'user_gender', width: 48 },
              // { id: 'user_age', title: '年龄', dataIndex: 'user_age', width: 48 },
              { id: 'user_occupation', title: '职业', dataIndex: 'user_occupation', width: 160 },
              { id: 'review_time', title: '测试时间', dataIndex: 'review_time', scopedSlots: { customRender: 'review_time' }, width: 110 },
              { id: 'platform', title: '平台', dataIndex: 'platform', width: 90 , scopedSlots: { customRender: 'platform_text' }},          
              { id: 'rate', title: `${this.selectedMode?.label}评分`, dataIndex: 'rate', width: 110 },
              { id: 'remark', title: '评分备注', dataIndex: 'remark', scopedSlots: { customRender: 'remark' }, },
              { id: 'facilitator', title: '主测人', dataIndex: 'facilitator', width: 150, },
              ...(this.canEdit ? [{ id: 'operator', title: '操作', scopedSlots: { customRender: 'operator' }, width: 120 }] : [])
            ]
      } else {
        const tmp = this.isSimple
          ? [
            { id: 'review_time', title: '测试日期', dataIndex: 'review_time', scopedSlots: { customRender: 'review_time' }, width: 110 },
            { id: 'total_count', title: '人数', dataIndex: 'total_count', width: 64 },
            { id: 'avg_rate', title: '平均分', dataIndex: 'avg_rate', scopedSlots: { customRender: 'decimal_num' }, width: 80 },
            { id: 'android_remark', title: '当日备注', dataIndex: 'android_remark' },
            { id: 'remark-operator', title: '操作', scopedSlots: { customRender: 'remark-operator' }, width: 120 },
          ]
          : [
            { id: 'review_time', title: '测试日期', dataIndex: 'review_time', scopedSlots: { customRender: 'review_time' }, width: 110 },
            { id: 'platform', title: '平台', dataIndex: 'platform', scopedSlots: { customRender: 'platform' }, width: 90 },
            {
              title: `Android（${this.selectedMode?.label}）`,
              children: [
                { id: 'android_count', title: '人数', dataIndex: 'android_count', width: 64 },
                { id: 'Android_avg_rate', title: '平均分', dataIndex: 'Android_avg_rate', scopedSlots: { customRender: 'decimal_num' }, width: 80 },
                {
                  id: 'android_remark',
                  title: this.selectedCategoryType === CATEGORY_TYPE_MAP.BASE ? '当日备注' : `本次测试备注`,
                  dataIndex: 'android_remark',
                  scopedSlots: { customRender: 'remark' },
                },
              ],
            },
            {
              title: `iOS（${this.selectedMode?.label}）`,
              children: [
                { id: 'ios_count', title: '人数', dataIndex: 'ios_count', width: 64 },
                { id: 'iOS_avg_rate', title: '平均分', dataIndex: 'iOS_avg_rate', scopedSlots: { customRender: 'decimal_num' }, width: 80 },
                { id: 'ios_remark', title: this.selectedCategoryType === CATEGORY_TYPE_MAP.BASE ? '当日备注' : `本次测试备注`, dataIndex: 'ios_remark', scopedSlots: { customRender: 'remark' } },
              ],
            },
            // { id: 'extra_remark', title: '其他', dataIndex: 'extra_remark', scopedSlots: { customRender: 'remark' }, width: 100 },
            { id: 'remark-operator', title: '操作', scopedSlots: { customRender: 'remark-operator' }, width: 120 },
          ];
        if (!this.isSimple && this.selectedCategoryType === CATEGORY_TYPE_MAP.BASE) {
          tmp.splice(-1, 0, {
            title: `手柄版（XGP）`,
            children: [
              { id: 'xgp_count', title: '人数', dataIndex: 'xgp_count', width: 64 },
              { id: '手柄版（XGP）_avg_rate', title: '平均分', dataIndex: '手柄版（XGP）_avg_rate', scopedSlots: { customRender: 'decimal_num' }, width: 80 },
              { id: 'xgp_remark', title: this.selectedCategoryType === CATEGORY_TYPE_MAP.BASE ? '当日备注' : `本次测试备注`, dataIndex: 'xgp_remark', scopedSlots: { customRender: 'remark' } },
            ],
          });
        }
        return tmp;
      }
    },
    exportData() {
      // 对data进行wrap
      return (this.dataSource || []).map(d => ({
        ...d,
        review_time: moment(d.review_time).format('YYYY/MM/DD')
      }));
    },
    exportColumns() {
      // return this.selectedDate ?
      return [];
    },
    dataSource() {
      if (this.selectedDate) {
        return this.data.filter(d => d.review_time === this.selectedDate)
      } else {
        const res = [];
        this.data.forEach(d => {
          const exist = res.find(r => r.review_time === d.review_time);
          const curPlatform = d.platform === 'iOS' ? 'iOS' : d.platform === '手柄版（XGP）' ? '手柄版（XGP）' : 'Android';
          if (!exist) {
            res.push({
              review_time: d.review_time,
              avg_rate: d.avg_rate,
              platform: d.platform,
              [`${curPlatform}_avg_rate`]: d.platform_rate,
              android_count: d.avg_rate_map.Android.count || '-',
              ios_count: d.avg_rate_map.iOS.count || '-',
              xgp_count: d.avg_rate_map["手柄版（XGP）"].count || '-',
              total_count: d.avg_rate_map.total.count || '-',
              android_remark: this.remarkMap[d.review_time]?.android_content || '-',
              ios_remark: this.remarkMap[d.review_time]?.ios_content || '-',
              xgp_remark: this.remarkMap[d.review_time]?.xgp_content || '-',
              extra_remark: this.remarkMap[d.review_time]?.extra_content,
            })
          } else {
            if (this.selectedPlatform === 'all' && exist.platform) {
              const tmp = exist.platform.split('/');
              if (d.platform && !tmp.includes(d.platform)) {
                tmp.push(d.platform);
              }
              exist.platform = tmp.sort((p, n) => p.length - n.length).join('/');
              //
              exist[`${curPlatform}_avg_rate`] = d.platform_rate;
            }
          }
        });
        return _.reverse(res);
      }
    },
    formModeRates() {
      if (!_.isNil(this.editItem?.mode_rate)) {
        return (Object.keys(this.editItem.mode_rate) || []).map(k => {
          const tar = this.modeOptions.find(mo => +mo.id === +k);
          return {
            label: `${tar?.label || '未知'}模式`,
            tarKey: `mode_rate.${k}`
          }
        })
      }
      return [];
    },
    rateLabel() {
      const { id, label } = this.selectedMode;
      if (id === MODE_ID_MAP.TROIS || id === MODE_ID_MAP.BUDDY_CUP) {
        return label;
      } else {
        return `整体`;
      }
    }
  },
  methods: {
    formatTime(t) {
      return moment(t).format('YYYY/MM/DD')
    },
    async handleEdit(item) {
      this.drawerVisible = true;
      this.editItem = item;
      this.$nextTick(function() {
        this.form.setFieldsValue({
          gender: item.user_gender,
          age: item.user_age,
          job: item.user_occupation,
          review_time: moment(item.review_time),
          platform: item.platform,
          rate: item.rate,
          mode_rate: item.mode_rate,
          remark: item.remark,
          facilitator: item.facilitator
        })
      });
    },
    deleteUserTest(item) {
      this.$service.addData(`${this.$service.api.project.query_fixed_module}experience_overview_delete/`, {
        id: item.review_id,
        type: this.selectedCategoryType
      }).then((d) => {
        this.$message.success(`删除玩家 ${item.review_id} 成功`);
        this.$emit('updateItem', 'delete', {
          ...item,
          type: this.selectedCategoryType
        });
      }).catch(err => {
        this.$message.error(`删除玩家 ${item.review_id} 失败`);
      })
    },
    handleCancelEdit() {
      this.drawerVisible = false;
      this.form.resetFields();
    },
    handleConfirmEdit() {
      this.form.validateFields().then(async () => {
        const formVals = this.form.getFieldsValue();
        const tmp_mode_rate = {};
        if (formVals.mode_rate) {
          formVals.mode_rate.forEach((v, idx) => {
            if (!_.isNil(v)) {
              tmp_mode_rate[idx] = v;
            }
          })
        }
        const tarReviewTime = moment((formVals.review_time || moment()).format("YYYY-MM-DD"));
        const params = {
          review_id: this.editItem.review_id,
          user_gender: formVals.gender,
          user_age: formVals.age,
          user_occupation: formVals.job,
          review_time: tarReviewTime.valueOf(),
          platform: formVals.platform,
          rate: formVals.rate,
          mode_rate: tmp_mode_rate,
          remark: formVals.remark,
          facilitator: formVals.facilitator,
        };

        this.$service.addData(`${this.$service.api.project.query_fixed_module}experience_overview_update/`, {
          id: this.editItem.review_id,
          data: params,
          type: this.selectedCategoryType
        }).then(d => {
          this.$message.success(`更新玩家 ${params.review_id} 成功`);

          this.drawerVisible = false;
          this.form.resetFields();
          this.$emit('updateItem', 'update', {
            ...params,
            type: this.selectedCategoryType
          });
        }).catch(err => {
          this.$message.error(`更新玩家 ${params.review_id} 失败`);
        })
      })
    },
    exportToExcel(filename) {
      exportFile(this.exportData, this.exportColumns, filename);
    },
    copy() {
      const copyData = [];
      copyData.push(this.exportColumns.map((dc) => dc.title).join('\t'));
      
      const tableData = [];
      (this.exportData || []).forEach(d => {
        const item = [];
        this.exportColumns.forEach(dc => {
          item.push(d[dc.dataIndex]);
        })
        tableData.push(item.join('\t'));
      });
      copyData.push(tableData.join('\n'));
      const clipboard = new Clipboard('#copy-btn', {
        text: () => copyData.join('\n'),
      })
      clipboard.on('success', e => {
        this.$message.success('复制成功')
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 不支持复制
        this.$message.success('该浏览器不支持自动复制')
        // 释放内存
        clipboard.destroy()
      })
    },
    handleEditRemark(item) {
      this.$emit('handleEditRemark', {
        label: item.review_time
      });
    },
    handleSelectDate(item) {
      this.$emit('changeSelectedDate', item.review_time);
    },
    isNumber(num) {
      return _.isNumber(num);
    }
  }
}
</script>

<style lang="less">
.ue-test-table-wrap {
  .i-platform {
    font-size: 20px;
    padding-right: 2px;
    &-xgp {
      width: calc(1em + 2px);
      position: relative;
      top: 1px;
      height: 1em;
      background: url(../../../../../public/static/admin/img/xbox.svg) 0 0 no-repeat;
    }
  }
  .remark-text {
    white-space: pre-line;
    text-align: left;
  }
  .ant-table-small>.ant-table-content>.ant-table-body {
    margin: 0;
  }
  .ant-table-thead > tr {
    background:#f2f2f2;
  }
}
</style>